<template>
  <div :class="'categorypage page ' + maincategory.slug ">
    <div class="columns">
      <div class="column">
        <div class="breadcrumb">
          <router-link to="/">KK</router-link> <i class="icon icon-chevron-right"></i> 
          <router-link :to="{ name: 'BioPage', params: { q: 'bio' }}">BIO</router-link>
        </div>
        <h1>BIO</h1>
      </div>
    </div>
    <div class="columns flex valign-top wrap quarter">
      <div class="column" v-for="(product, i) in productsBio" :key="i">
         <router-link class="product-preview-link" :to="{ name: 'DetailPage', params: { pg: product.pg, artnr: product.artnr } }">
              <div class="prod-img-container">
                <img loading="lazy" width="1000" height="1000" v-if="product.bild != '' && ImageExist( '/upload/product-images/' + product.bild ) " :src=" '/upload/product-images/' + product.bild ">
                <img loading="lazy" width="1000" height="1000" class="placholder" v-else :src=" product.bio == 'J' ? '/upload/product-images/platzhalter_bio_bw.png':'/upload/product-images/platzhalter_artikelohnefoto.svg' ">
              </div>
              
              <span class="link-label-product-preview">{{product.bez1}}</span>
          </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import Productpreview from '../views/Productpreview'
import products       from '../data/etar2.json';
import categories     from '../data/categories.json';
import productsinfo   from '../data/etais.json';

export default {
    name: 'BioPage',
    data: function(){
      return {
         productsBio: [],
         subcategory: {},
         maincategory: {}
      }
    },
    
    created: function(){
      //console.log(this.items);
      this.filterResults()
      //console.log(this.product)
    },
    watch: {
    '$route.params': function () {
      this.filterResults()
      },
   
    },
    methods: {
      ImageExist(url) {
           var img = new Image();
           img.src = url;
           //console.log(img.width);
           return true //img.width > 0;
        },
        
      filterResults(){

          var productsTemp = products.filter((item) => { return item.bio != "" });

          if( productsTemp.length > 0) { 
            
            var uniquePGs = [];
            
            let result = [];
            uniquePGs = new Map();
            for (const item of productsTemp) {
                if(!uniquePGs.has(item.pg)){
                    uniquePGs.set(item.pg, true);    // set any value to Map
                    this.productsBio.push( item )
                }
            }
          } // if

      }
    }
}
</script>
<style scoped>
/*
  .productpage .label { display: inline-block; min-width: 10em; }
  .productpage .product-info .p-detail { padding: 0.91333333em; border-top: 1px solid #ededef; }
  .productpage .product-info .p-detail:last-child { border-bottom: 1px solid #ededef; }
*/
  .categorypage .prod-img-container { overflow: hidden; }

  .p-bio img { display: inline-block; max-width: 6em;  }
  .product-preview-link { color: #00853e; text-decoration: none; }
  .product-preview-link span { display: block; padding: 0.222222em 0; }
  .product-preview-link img { transform: scale(1.01); transition: transform 2s ease-out; display: block; width: 100%; max-width: 100%; height: auto; }
  .product-preview-link:hover img { transform: scale(1.08); }
/*   .placholder { opacity: 0.3; } */
</style>
